import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Globals } from '../../../_globals/globals';

import { Translation } from '../../../_languages/translations';

@Component({
  selector: 'app-main-show',
  templateUrl: './main-show.component.html'
})

export class MainShowComponent implements OnInit {

  // Para el control del diccionario de traducción.
  tr: {};

  title: string;
  subtitle: string;
  
  // Id del usuario actual logueado.
  current_user_id: number;
  current_group_id: number;
  current_username: string;
  current_enviroment: string;

  permissions: string;
  permissions_list: any;
  permissions_role_list: any;
  canSeeAutoOpti = false;
  isManufacturer = false;
  canSeeMasters = false;
  canSeeOptimizations = false;
  canSeeProductivity = false;

  constructor(
    public router: Router,
    private globals: Globals,
    public trans: Translation
  ) {}

  ngOnInit() {

    this.tr = this.trans.vocabulary;

    this.title = this.tr['ms1_title'];
    this.subtitle = this.tr['ms1_subtitle'];

    console.log('-> -> Iniciando Main-Show:' + this.title);

    this.permissions = localStorage.getItem('permissions');
    console.log('-> -> Iniciando Main-Show permissions:' + this.permissions);
    
    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_group_id = Number(localStorage.getItem('group_id'));
    this.current_username = localStorage.getItem('username');
    this.current_enviroment = localStorage.getItem('enviroment');

    this.permissions_list = this.globals.permissionList[this.current_enviroment];
    console.log('-> permissions_list:');
    console.log(this.permissions_list);
    
    this.permissions_role_list = this.globals.permissionRoleList[this.current_enviroment];
    console.log('-> permissions_role_list:');
    console.log(this.permissions_role_list);

    const hasManufacturerPermission = this.permissions === 'Manufacturer';
    this.isManufacturer = hasManufacturerPermission;
    this.canSeeMasters = hasManufacturerPermission || this.permissions_role_list['admin'].indexOf(this.permissions) > -1;
    this.canSeeOptimizations = hasManufacturerPermission || this.permissions_role_list['optimizado'].indexOf(this.permissions) > -1;
    this.canSeeProductivity = !this.isManufacturer &&
      (hasManufacturerPermission || this.permissions_role_list['optimizado'].indexOf(this.permissions) > -1);

    // Mantener el mismo criterio de visibilidad que el guard de rutas.
    this.canSeeAutoOpti = !this.isManufacturer && this.globals.urlPermisionList['/auto-opti-lote']
      .indexOf(this.permissions) > -1;
  }

  selectSection(value: string) {
    console.log('-> -> Seleccionada sección:' + value);

    this.router.navigate(['/' + value]);
  }
} // End MainShowComponent
